const DESCRIPTION_EDITOR_HEIGHT = '145px'
const MAX_DESCRIPTION_LENGTH = 500

export const descriptionEditorContainerStyle = {
  flex: '1'
}

export const characterCountStyle = {
  marginTop: '$1',
  textAlign: 'right',
  fontSize: '$caption',
  color: '$medium-medium',
  display: 'block'
}

export { DESCRIPTION_EDITOR_HEIGHT, MAX_DESCRIPTION_LENGTH }
